import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CapitalizePipe } from '../../../../pipesFiles/capitalize.pipe';
import { SafePipe } from '../../../../pipesFiles/safe.pipe';
import { spekwo, spekwoType } from '../../../../utils/index';
import { SolutionFormService } from '../../../solutionForm/solutionForm.service';
import * as html2pdf from 'html2pdf.js';

@Component({
  selector: 'app-pre-list-print',
  templateUrl: './pre-list-print.component.html',
  styleUrls: ['./pre-list-print.component.scss'],
  providers: [
    CapitalizePipe,
    SafePipe,
  ]
})

export class PreListPrintComponent implements OnInit {

  spekwoValues = spekwo;
  spekwoType = spekwoType;
  insReportId: any;
  fullName: any;
  clientName: any;
  buyerAddress: any;
  currentOrderChangedSubscription: any;
  currentOrderDetails: any;
  insReportIdChangeSubscription: any;
  orderTypeChangeSubscription: any;
  buyerPropertyChangesSubscription: any;
  buyerProperty: any;
  clientRoleChangeSubscription: any;
  clientNameSubscription: any;
  orderType: any;
  agent: any;
  picturesDetails: any;
  images: any = [];



  constructor(
    /**Details of table data*/
    @Inject(MAT_DIALOG_DATA) public data: any,
    /**Service  file */
    private solutionFormService: SolutionFormService,
    /**pipe file */
    public capitalizePipe: CapitalizePipe,
    /**pipe file */
    public SafePipe: SafePipe,
  ) { }

  async ngOnInit() {
    this.picturesDetails = this.data.picturesDetails;
    await this.imagesIterateForBase64();

    // this.picturesDetails.forEach(element => {
    //   if (element && element.image) {
    //     if (element.image.length > 0) {
    //       let tempImageArr = [];
    //       for (let j = 0; j < element.image.length; j++) {
    //         this.getBase64ImageFromUrl(element.image[j]).then(result => {
    //           tempImageArr.push(result);
    //           if (j + 1 == element.image.length) {
    //             this.images.push(tempImageArr);
    //           }
    //         });
    //       }
    //     }
    //     else {
    //       this.getBase64ImageFromUrl(element.image).then(result => {
    //         this.images.push(result);
    //       });
    //     }
    //   }

    // });

    this.currentOrderChangedSubscription =
      this.solutionFormService.currentOrderChanged.subscribe(res => {
        if (res) {
          this.currentOrderDetails = res;
          this.fullName = res.billing.first_name + ' ' + res.billing.last_name;
        }
      }, () => {

      })

    /**Inspection id  */
    this.insReportIdChangeSubscription =
      this.solutionFormService.insReportIdChange.subscribe(insRes => {
        this.insReportId = insRes && insRes.insReportId;
      })

    /**Order type */
    this.orderTypeChangeSubscription =
      this.solutionFormService.orderTypeChange.subscribe(typeRes => {
        this.orderType = typeRes;
      })

    /**Buyer property */

    this.buyerPropertyChangesSubscription =
      this.solutionFormService.buyerPropertyChanges.subscribe(propertyRes => {
        this.buyerProperty = propertyRes;
      })

    /**Client  role */
    this.clientRoleChangeSubscription =
      this.solutionFormService.clientRoleChange.subscribe(roleRes => {
        this.agent = this.spekwoValues[roleRes];
      })

    /**Client  Name -not billing name .Its separate field */
    this.clientNameSubscription =
      this.solutionFormService.clientNameChange.subscribe(data => {
        this.clientName = data && data.name;
      })
  }

  async imagesIterateForBase64() {
    for (let i = 0; i < this.picturesDetails.length; i++) {
      if (this.picturesDetails[i] && this.picturesDetails[i].image) {
        if (this.picturesDetails[i].image.length > 0) {
          let tempImageArr = [];
          for (let j = 0; j < this.picturesDetails[i].image.length; j++) {
            await this.getBase64ImageFromUrl(this.picturesDetails[i].image[j]).then(result => {
              tempImageArr.push(result);
              if (j + 1 == this.picturesDetails[i].image.length) {
                this.images.push(tempImageArr);
              }
            });
          }
        }
        else {
          await this.getBase64ImageFromUrl(this.picturesDetails[i].image).then(result => {
            this.images.push(result);
          });
        }
      }
    }
  }

  async getBase64ImageFromUrl(imageUrl) {
    return new Promise((resolve, reject) => {
      this.convertImgToBase64URL(imageUrl, async function (dataUrl) {
        await resolve(dataUrl);
      }, null);
    })
  }


  convertImgToBase64URL(url, callback, outputFormat) {
    var canvas = document.createElement('canvas'),
      ctx = canvas.getContext('2d'),
      img = new Image;
    img.crossOrigin = 'Anonymous';
    img.onload = function () {
      var dataURL;
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      dataURL = canvas.toDataURL(outputFormat);
      callback(dataURL);
      canvas = null;
    };
    img.src = url;
  }

  downloadPreListSheet() {
    var element = document.getElementById('printForm');
    var name = this.capitalizePipe.transform(this.fullName);
    var buyerProperty = this.capitalizePipe.transform(this.buyerProperty);

    html2pdf(element, {
      margin: 1,
      filename: name + '-' + buyerProperty + '-' + 'Pre-List Spek-Sheet .pdf',
      image: { type: 'base64', quality: 1 },
      html2canvas: { useCORS: false, scale: 2 },
      jsPDF: { unit: 'cm', format: 'a2', orientation: 'p' },
      pagebreak: { mode: 'avoid-all', after: '.break-after', before: '.break-before' }
    });

  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/pre-list-print/pre-list-print.component.ts